import DashView from './components/Dash.vue'
import LoginView from './components/Login.vue'
import NotFoundView from './components/404.vue'
// Import Views - Dash
import ProfileView from './components/views/Profile.vue'
import DashboardView from './components/views/Dashboard.vue'

import AddItemView from './components/views/AddItem.vue'
import SalesView from './components/views/SalesTable.vue'
import WarehouseView from './components/views/WarehouseTable.vue'
import PurchaseView from './components/views/PurchaseTable.vue'
import UserView from './components/views/UserTable.vue'

// Routes
const routes = [
  {
    path: '/',
    component: LoginView
  },
  {
    path: '/manage',
    component: DashView,
    children: [
      {
      //   path: 'dashboard',
      //   alias: '',
      //   component: DashboardView,
      //   name: '首页',
      //   meta: {description: '我的首页'}
      // }, {
        path: 'sales',
        alias: '',
        component: SalesView,
        name: '销售流向查询',
        meta: {description: '销售流向'}
      }, {
        path: 'warehouse',
        component: WarehouseView,
        name: '库存数据查询',
        meta: {description: '库存数据'}
      }, {
        path: 'purchase',
        component: PurchaseView,
        name: '采购流向查询',
        meta: {description: '采购流向'}
      }, {
        path: 'user',
        component: UserView,
        name: '用户管理',
        meta: {description: '用户管理'}
        }, {
        path: 'addItem',
        component: AddItemView,
        name: '添加关联商品',
        meta: {description: '添加关联商品'}
      }, {
        path: 'profile',
        component: ProfileView,
        name: '用户信息',
        meta: {description: ''}

      }
    ]
  }, {
    // not found handler
    path: '*',
    component: NotFoundView
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js